module.exports = __webpack_public_path__ + "static/media/slide-7.a6bf8115.png";